const riot = require('riot');

riot.tag2('module-project-select', '<div class="flex-fixed s-full p8 bg-white rounded-4 box-shadow hover-trigger hover-bg-label_pale transition"> <div class="text-label_low fs12 lh15 mb8">プロジェクト</div> <label class="relative block"> <input class="input w-full pl18 pr14 py4 focus-primary focus-text-label_high fs12 bold" ref="project_select" riot-style="color: {currentProject ? currentProject.getColor() : &quot;&quot;};" riot-value="{currentProject ? currentProject.data.name : &quot;all&quot;}" placeholder="プロジェクト" onclick="{onOpenPopupSelect}" oninput="{projectPopup ? debounceSearchProjects : onOpenPopupSelect}" onblur="{closeProjectPopup}" onkeydown="{projectPopup.selectionList.onKeyDown}"> <div class="absolute l4 t9 z1 s6 circle mr4 {&quot;bg-label_low&quot; : !currentProject}" if="{document.activeElement !== refs.project_select}" riot-style="background-color: {currentProject.data.color || app.utils.defaultColor};"></div><i class="absolute l4 t4 z1 icon-project text-label_medium fs12 mr4" if="{document.activeElement === refs.project_select}"></i><i class="icon-close absolute t4 r4 z1 text-label_medium fs12 cursor-pointer" if="{refs.project_select.value}" onclick="{onDeleteText}"></i> </label> </div>', 'module-project-select,[data-is="module-project-select"]{display:block} module-project-select .focus-text-label_high:focus-within,[data-is="module-project-select"] .focus-text-label_high:focus-within{color:#2E2E38 !important}', '', function(opts) {
    this.setup = () => {
      this.currentProject = this.opts.currentProject;
      this.update();
    };

    this.onOpenPopupSelect = (e) => {

      if (this.projectPopup) return;

      this.refs.project_select.select();
      this.projectPopup = spat.popup.open('popup-select', {
        element: e.currentTarget,
        align: { x:'left' },
        offsetTop: 10,
        position: 'bottom',
        opts: {
          options: () => { return this.getSearchProjects(); },
          kind: 'project'
        },
      }).on('select', ({ option: project }) => {
        this.currentProject = project;
        this.refs.project_select.value = project ? project.data.name : '';
        this.update();
        this.trigger('select', project);
      }).on('close', () => {

        this.refs.project_select.blur();
        this.projectPopup = null;
        this.update();
      });
      this.searchProjects();
    };

    this.closeProjectPopup = () => {
      if (!this.projectPopup) return;
      if (this.refs.project_select) {
        this.projectPopup.selectCurrent();
      }
      else {
        this.projectPopup.close();
      }
    };

    this.getSearchProjects = () => {
      if (!this.refs.project_select) return [];
      var projects = this.refs.project_select.value ? this.displayProjects : this.opts.projects;
      return  projects;
    };

    this.searchProjects = () => {
      if (!this.projectPopup) return ;
      const value = this.refs.project_select.value;
      const keyword = value.toLowerCase();
      this.displayProjects = this.opts.projects.map(project => {
        const index = project.data.name.toLowerCase().indexOf(keyword);
        return { index, project };
      }).filter(item => item.index >= 0).sort((a, b) => a.index - b.index).map(item => item.project);
      this.update();
      this.projectPopup.setItems();
      this.projectPopup.update();
    };

    this.debounceSearchProjects = _.debounce(() => {
      this.searchProjects();
    }, 64);

    this.onDeleteText = () => {
      this.refs.project_select.value = '';
      this.update();
    };
});